// src/pages/ComplaintForm.jsx
import React, { useState } from "react";
import axios from "axios";

export default function TakrarNivaranPortal() {
  const [formData, setFormData] = useState({
    name: "",
    designation: "",
    phone: "",
    email: "",
    photo: null,
  });

  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "photo") {
      setFormData({ ...formData, photo: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append("name", formData.name);
    data.append("designation", formData.designation);
    data.append("phone", formData.phone);
    data.append("email", formData.email);
    if (formData.photo) data.append("photo", formData.photo);

    try {
      await axios.post("https://gp-chandoli-khurd.com/backend/api/complaint_portal/post_comp_portal.php", data, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setMessage("तुमची तक्रार यशस्वीरित्या सबमिट झाली!");
      setFormData({
        name: "",
        designation: "",
        phone: "",
        email: "",
        photo: null,
      });
    } catch (error) {
      console.error(error);
      setMessage("तक्रार सबमिट करताना त्रुटी आली.");
    }
  };

  return (
    <div className="max-w-xl mx-auto p-4 bg-white shadow-md rounded-md">
      <h1 className="text-2xl font-bold mb-4">तक्रार निवारण फॉर्म</h1>

      {message && <p className="mb-4 text-green-600">{message}</p>}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block font-medium mb-1">नाव</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div>
          <label className="block font-medium mb-1">पद</label>
          <input
            type="text"
            name="designation"
            value={formData.designation}
            onChange={handleChange}
            required
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div>
          <label className="block font-medium mb-1">फोन</label>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div>
          <label className="block font-medium mb-1">ईमेल</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div>
          <label className="block font-medium mb-1">फोटो अपलोड</label>
          <input
            type="file"
            name="photo"
            onChange={handleChange}
            className="w-full"
          />
        </div>

        <button
          type="submit"
          className="bg-custom-orange text-white px-4 py-2 rounded hover:bg-orange-600 transition-colors"
        >
          सबमिट करा
        </button>
      </form>
    </div>
  );
}
